import React, { useState } from "react";
import { Drawer, Modal, Input, Button } from "antd";
import { Search, X, ChevronsRight, ChevronsLeft } from "react-feather";
import NvwButton from "../nvw-button";
import Logo from "../logo";
import {
	IconAdvanced,
	IconCoach,
	IconContact,
	IconLeader,
	IconMobileMenu,
	IconPersonal,
} from "../icons";

const { Search: SearchInput } = Input;

const subMenu = {
	programPaths: [
		{
			icon: <IconCoach size={25} fill={"var(--wp--preset--color--cerulean)"} />,
			heading: "Coach Certification",
			href: "/coach-certification",
			subHeading:
				"Develop the capacity, presence, and skill to meet people where they are, with training to support every step of your journey.",
		},
		{
			icon: (
				<IconPersonal size={25} fill={"var(--wp--preset--color--mahogany)"} />
			),
			heading: "Personal Development",
			href: "/personal-development",
			subHeading:
				"Discover your depths and start from where you are with the support of a compassionate community of like-hearted learners.",
		},
		{
			icon: <IconLeader size={25} fill={"var(--wp--preset--color--pine)"} />,
			heading: "Leadership Development",
			href: "/leadership-development	",
			subHeading:
				"Drive greater alignment, effectiveness and wellbeing across your organization by nurturing leadership skills at every level.",
		},
		{
			icon: <IconAdvanced size={25} fill={"var(--wp--preset--color--daisy)"} />,
			heading: "Advanced Training",
			href: "/advanced-training",
			subHeading:
				"Cultivate your quality of presence, effectiveness, and support as you deepen into your own development as a coach.",
		},
	],
	integralCoaching: [
		{
			heading: "How it Works",
			href: "/integral-coaching/how-it-works/",
			subHeading:
				"Open to new possibilities for yourself and your clients, grounded in our rigorous Integral Coaching methodology.",
		},
		{
			heading: "Our Approach",
			href: "/integral-coaching/our-approach/",
			subHeading:
				"As the global leader in Integral Coach training and leadership development, we support how people deepen into their unique gifts.",
		},
		{
			heading: "Integral Coaching Glossary",
			href: "/integral-coaching/integral-coaching-glossary/",
			subHeading:
				"New to Integral Coaching? Familiarize yourself with the language of our methodology and coaching more broadly.",
		},
		{
			heading: "Integral Coaching FAQ",
			href: "/integral-coaching/integral-coaching-faq/",
			subHeading:
				"Living the questions? Find answers here to some of the most common questions we receive about our programs.",
		},
	],
	aboutUs: [
		{
			icon: (
				<IconContact size={25} fill={"var(--wp--preset--color--cerulean)"} />
			),
			heading: "Contact Us",
			href: "/about-us/contact-us",
			subHeading:
				"Relationships are at the heart of our work. Reach out to explore how Integral Coaching could support your journey.",
		},
		{
			heading: "Leadership Model",
			href: "/about-us/leadership-model",
			subHeading:
				"We strive for balance in all we do, including stewarding the rich history of this work, this organization, and this community. ",
		},
		{
			heading: "Our Commitments	",
			href: "/about-us/our-values/",
			subHeading:
				"What we value guides everything we do—from the programs we design to the communities we foster. Learn more about what motivates us.",
		},
		{
			heading: "Our History",
			href: "/about-us/our-history/",
			subHeading:
				"New Ventures West has pioneered one of the most transformative forms of human development over four decades.",
		},
		{
			heading: "Staff & Faculty",
			href: "/about-us/staff-faculty",
			subHeading:
				"Your journey is supported at every step by dedicated, compassionate people committed to your growth, learning, and wellbeing.",
		},
	],
};

const HeaderDrawer = ({ onClick }) => (
	<div>
		<div className="wp-block-buttons text-right">
			<div
				className="wp-block-button has-custom-font-size is-style-outline has-abc-arizona-flare-font-family"
				style={{ fontSize: "16px" }}
			>
				<a
					className="wp-block-button__link has-fog-color has-clear-background-color has-text-color has-background wp-element-button"
					onClick={onClick}
				>
					<span className="text-obsidian font-medium flex items-center w-18">
						Close <X size={"16px"} className={"ml-2"} />
					</span>
				</a>
			</div>
		</div>
	</div>
);

const FooterDrawer = () => {
	// Get the Query args 's'
	const urlParams = new URLSearchParams(window.location.search);
	const querySearch = urlParams.get("s");

	const [isModalOpen, setIsModalOpen] = useState(false);
	const [searchTerm, setSearchTerm] = useState(querySearch || "");

	const showModal = () => {
		setIsModalOpen(true);
	};

	const handleCancel = () => {
		setIsModalOpen(false);
	};

	const onSearchSubmit = (e) => {
		e.preventDefault();

		if (searchTerm === "") return;

		window.location.replace(`/?s=${searchTerm}`);
	};

	return (
		<div>
			<div className={"mb-2.5"}>
				<NvwButton href={"/get-started"} isBlock={true} fontWeight={"semibold"}>
					Get Started
				</NvwButton>
			</div>
			<div className="flex gap-2.5 justify-between">
				<NvwButton fontWeight={"normal"} className={"px-3"} onClick={showModal}>
					<Search />
				</NvwButton>
				<NvwButton href={"/my-account"} fontWeight={"normal"}>
					Sign In
				</NvwButton>
				<NvwButton href={"/cart"} fontWeight={"normal"} className={"px-5"}>
					<svg
						width="20"
						height="21"
						viewBox="0 0 20 21"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M0 3.13867C0 2.86253 0.224319 2.63867 0.500462 2.63867C1.70342 2.63867 2.46627 2.63867 2.91732 2.63867C3.24655 2.63867 3.53718 2.8534 3.63402 3.16807L6.29298 11.8081C6.35754 12.0179 6.55137 12.1611 6.77086 12.1611H16.1513C16.3722 12.1611 16.5669 12.0162 16.6303 11.8046L17.9588 7.37132C18.0309 7.13074 17.8508 6.88867 17.5996 6.88867H7.46916C7.19302 6.88867 6.96916 6.66481 6.96916 6.38867V6.13867C6.96916 5.86253 7.19302 5.63867 7.46916 5.63867H17.5996C18.6879 5.63867 19.4686 6.68763 19.1562 7.73014L17.7209 12.5199C17.5624 13.0488 17.0756 13.4111 16.5235 13.4111H6.4016C5.85594 13.4111 5.37333 13.0571 5.20936 12.5367L2.53119 3.88867H0.5C0.223858 3.88867 0 3.66481 0 3.38867V3.13867Z"
							fill="var(--wp--preset--color--obsidian)"
						/>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M15.6562 16.5859C15.0349 16.5859 14.5312 17.0896 14.5312 17.7109C14.5312 18.3323 15.0349 18.8359 15.6562 18.8359C16.2776 18.8359 16.7812 18.3323 16.7812 17.7109C16.7812 17.0896 16.2776 16.5859 15.6562 16.5859ZM13.2812 17.7109C13.2812 16.3993 14.3446 15.3359 15.6562 15.3359C16.9679 15.3359 18.0312 16.3993 18.0312 17.7109C18.0312 19.0226 16.9679 20.0859 15.6562 20.0859C14.3446 20.0859 13.2812 19.0226 13.2812 17.7109Z"
							fill="var(--wp--preset--color--obsidian)"
						/>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M7.02002 16.5859C6.3987 16.5859 5.89502 17.0896 5.89502 17.7109C5.89502 18.3323 6.3987 18.8359 7.02002 18.8359C7.64134 18.8359 8.14502 18.3323 8.14502 17.7109C8.14502 17.0896 7.64134 16.5859 7.02002 16.5859ZM4.64502 17.7109C4.64502 16.3993 5.70834 15.3359 7.02002 15.3359C8.3317 15.3359 9.39502 16.3993 9.39502 17.7109C9.39502 19.0226 8.3317 20.0859 7.02002 20.0859C5.70834 20.0859 4.64502 19.0226 4.64502 17.7109Z"
							fill="var(--wp--preset--color--obsidian)"
						/>
					</svg>
				</NvwButton>
			</div>
			<Modal
				className="[&_div]:!bg-obsidian [&_div]:!text-white"
				title="Search"
				open={isModalOpen}
				onCancel={handleCancel}
				footer={[]}
				closeIcon={<X className="!stroke-white" />}
			>
				<form role="search" onSubmit={onSearchSubmit}>
					<Input
						size="large"
						placeholder="Search..."
						className="rounded-full px-3 !font-arizona !text-xl"
						allowClear
						value={searchTerm}
						onChange={(e) => setSearchTerm(e.target.value)}
						onPressEnter={onSearchSubmit}
					/>
					<Button
						type="submit"
						className="mt-4 rounded-full !text-obsidian font-arizona font-semibold !bg-fog text-xl py-0 px-4 [&>span]:leading-none"
						onClick={onSearchSubmit}
					>
						Search
					</Button>
				</form>
			</Modal>
		</div>
	);
};

export default function MobileMenu() {
	const [open, setOpen] = useState(false);
	const [childrenDrawer, setChildrenDrawer] = useState(false);
	const [activeSubMenu, setActiveSubMenu] = useState("programPaths");

	const showDrawer = () => setOpen(true);

	const closeDrawer = () => setOpen(false);

	const showChildrenDrawer = () => setChildrenDrawer(true);

	const onChildrenDrawerClose = () => setChildrenDrawer(false);

	return (
		<>
			<div className="wp-block-buttons text-right">
				<div
					className="wp-block-button has-custom-font-size is-style-outline has-abc-arizona-flare-font-family"
					style={{ fontSize: "16px" }}
				>
					<a
						className="wp-block-button__link has-fog-color has-clear-background-color has-text-color has-background wp-element-button"
						onClick={showDrawer}
					>
						<span className="text-obsidian flex items-center w-18">
							Menu{" "}
							<span className={"ml-2"}>
								<IconMobileMenu />
							</span>
						</span>
					</a>
				</div>
			</div>
			<Drawer
				title={
					<div className="flex items-center">
						<Logo fill={`var(--wp--preset--color--ash)`} />
					</div>
				}
				placement="right"
				onClose={closeDrawer}
				open={open}
				closable={false}
				style={{ width: "100% !important" }}
				extra={<HeaderDrawer onClick={closeDrawer} />}
				footer={<FooterDrawer />}
			>
				<nav>
					<ul className="flex flex-col gap-2.5 !list-none">
						<li>
							<a
								href="#"
								className={
									"flex w-full items-center text-clear font-arizona text-3xl font-light py-2.5 hover:text-clear visited:text-clear focus:text-clear"
								}
								onClick={(e) => {
									e.preventDefault();
									setActiveSubMenu("programPaths");
									showChildrenDrawer();
								}}
							>
								Program Paths <ChevronsRight className={"ml-2.5"} />
							</a>
						</li>
						<li>
							<a
								href="#"
								className={
									"flex w-full items-center text-clear font-arizona text-3xl font-light py-2.5 hover:text-clear visited:text-clear focus:text-clear"
								}
								onClick={(e) => {
									e.preventDefault();
									setActiveSubMenu("integralCoaching");
									showChildrenDrawer();
								}}
							>
								Integral Coaching <ChevronsRight className={"ml-2.5"} />
							</a>
						</li>
						<li>
							<a
								href="#"
								className={
									"flex w-full items-center text-clear font-arizona text-3xl font-light py-2.5 hover:text-clear visited:text-clear focus:text-clear"
								}
								onClick={(e) => {
									e.preventDefault();
									setActiveSubMenu("aboutUs");
									showChildrenDrawer();
								}}
							>
								About Us <ChevronsRight className={"ml-2.5"} />
							</a>
						</li>
						<li>
							<a
								href="/resources"
								className={
									"flex w-full items-center text-clear font-arizona text-3xl font-light py-2.5 hover:text-clear visited:text-clear focus:text-clear"
								}
							>
								Resources
							</a>
						</li>
						<li>
							<a
								href="/class-schedule"
								className={
									"flex w-full items-center text-clear font-arizona text-3xl font-light py-2.5 hover:text-clear visited:text-clear focus:text-clear"
								}
							>
								Class Schedule
							</a>
						</li>
					</ul>
				</nav>
				<Drawer
					title={
						<div className="flex items-center">
							<Logo fill={`var(--wp--preset--color--ash)`} />
						</div>
					}
					placement="right"
					open={childrenDrawer}
					closable={false}
					style={{ width: "100% !important" }}
					extra={<HeaderDrawer onClick={onChildrenDrawerClose} />}
					footer={<FooterDrawer />}
				>
					<div className={"mb-3.5"}>
						<NvwButton
							href={"#"}
							isBlock={true}
							fontWeight={"semibold"}
							onClick={onChildrenDrawerClose}
						>
							<span
								className={
									"flex text-obsidian hover:text-obsidian visited:text-obsidian focus:text-obsidian"
								}
							>
								Back to Main Menu <ChevronsLeft />
							</span>
						</NvwButton>
					</div>
					<div className={"flex flex-col gap-2.5"}>
						{activeSubMenu &&
							subMenu[activeSubMenu].map((item) => (
								<div
									key={item?.heading}
									className={
										"flex flex-col gap-y-1.5 border rounded-md border-charcoal p-3.5"
									}
								>
									{item?.icon || null}
									{item?.heading && (
										<h2 className={"text-clear typography-p2"}>
											<a
												href={`${item?.href ?? "#"}`}
												className={
													"text-clear hover:text-white visited:text-white focus:text-white"
												}
											>
												{item.heading}
											</a>
										</h2>
									)}
									{item?.subHeading && (
										<p className={"typography-p3 text-clear"}>
											{item.subHeading}
										</p>
									)}
								</div>
							))}
					</div>
				</Drawer>
			</Drawer>
		</>
	);
}
